import { formatLocalizedDate } from "../misc/RelativeDate";

export const formatNumber = (value: unknown, locale: string) =>
  Number.isFinite(Number(value))
    ? new Intl.NumberFormat(locale).format(Number(value))
    : String(value);

export const formatCurrency = (
  value: unknown,
  locale: string,
  currency: string,
) =>
  Number.isFinite(Number(value))
    ? new Intl.NumberFormat(locale, {
        style: "currency",
        currency,
        maximumFractionDigits: 0,
      }).format(Number(value))
    : String(value);

export const formatDate = (value: unknown, locale: string) => {
  const date = String(value);
  return Number.isNaN(new Date(date).getTime())
    ? date
    : formatLocalizedDate(date, locale);
};
